import { pageWidth } from 'shared/lib'
import styled from 'styled-components'

// specs show 1020 as max width for the full page grid content
export const GridContent = styled.div`
  ${pageWidth}
  margin: auto;
`
